import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { WithStyles } from 'decorators/withStyles';
import React, { memo } from 'react';

import styles from './styles';

import type { IStyledProps } from 'decorators/withStyles';

type TableOptionsItem = {
  icon?: string;
  label: string;
  callback: Function;
  disabled?: boolean;
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
};

interface IProps extends IStyledProps {
  items: number;
  options: Array<TableOptionsItem>;
  style?: React.CSSProperties;
}

const TableOptions = ({ classes, items, options, style }: IProps) => {
  if (!items) {
    return null;
  }

  return (
    <div className={classes.tableOptions} style={{ ...style }}>
      <Grid container spacing={1} justify='space-between'>
        <Grid item xs={12} md={4}>
          <div className='count'>{`${items} ${items > 1 ? 'selecionados' : 'selecionado'}`}</div>
        </Grid>

        <Grid item xs={12} md={8}>
          <div className='options'>
            {options.map((opt, i) => (
              <Button
                size='small'
                variant='text'
                color={opt.color || 'default'}
                onClick={() => opt.callback()}
                key={`option-${i}`}
                disabled={opt.disabled}
              >
                {opt.icon && <Icon color='inherit'>{opt.icon}</Icon>}
                {opt.label}
              </Button>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(WithStyles(styles)(TableOptions));
